<form [formGroup]="stockForm" (ngSubmit)="addToList()" class="flex flex-col gap-6">
  <div class="flex flex-col gap-6 rounded-2xl border border-gray-100 bg-white p-8 shadow-sm">
    <h3 class="text-primary text-[20px] font-bold">Add Stock Information</h3>

    <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
      <div class="relative flex flex-col gap-2">
        <label class="text-[13px] font-semibold text-gray-700">Product *</label>
        <input
          type="text"
          formControlName="productSearch"
          (input)="onProductSearch($event)"
          placeholder="Search Product..."
          class="bg-surface-subtle focus-border-primary w-full rounded-[10px] border border-gray-300 px-4 py-2.5 text-[14px] outline-none" />

        <div
          *ngIf="showProductAutocomplete() && productsAutocomplete().length > 0"
          class="absolute z-50 mt-20 max-h-48 w-full overflow-y-auto rounded-md border border-gray-200 bg-white shadow-xl">
          <div
            *ngFor="let prod of productsAutocomplete()"
            (click)="selectProduct(prod)"
            class="hover-bg-primary-10 hover-text-primary cursor-pointer border-b border-gray-50 px-4 py-2 text-[13px] last:border-0">
            {{ getTranslatedTitle(prod) }}
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <label class="text-[13px] font-semibold text-gray-700">Supplier *</label>
        <select
          formControlName="supplierId"
          class="bg-surface-subtle rounded-[10px] border border-gray-300 px-4 py-2.5 text-[14px] outline-none">
          <option [value]="null" disabled>Select Supplier</option>
          <option *ngFor="let supplier of suppliers()" [value]="supplier.id">{{ getTranslatedTitle(supplier) }}</option>
        </select>
      </div>

      <div class="flex flex-col gap-2">
        <label class="text-[13px] font-semibold text-gray-700">Quantity *</label>
        <input
          type="number"
          formControlName="quantity"
          class="bg-surface-subtle rounded-[10px] border border-gray-300 px-4 py-2.5 text-[14px]" />
      </div>
    </div>

    <app-product-prices></app-product-prices>

    <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
      <div class="flex flex-col gap-2">
        <label class="text-[13px] font-semibold text-gray-700">Batch No. *</label>
        <input
          type="text"
          formControlName="batchNumber"
          class="bg-surface-subtle rounded-[10px] border border-gray-300 px-4 py-2.5 text-[14px]" />
      </div>

      <div class="flex flex-col gap-2">
        <label class="text-[13px] font-semibold text-gray-700">MFG Date *</label>
        <input
          type="date"
          formControlName="mfgDate"
          class="bg-surface-subtle rounded-[10px] border border-gray-300 px-4 py-2.5 text-[14px]" />
      </div>

      <div class="flex flex-col gap-2">
        <label class="text-[13px] font-semibold text-gray-700">EXP Date *</label>
        <input
          type="date"
          formControlName="expDate"
          class="bg-surface-subtle rounded-[10px] border border-gray-300 px-4 py-2.5 text-[14px]" />
      </div>
    </div>

    <div class="flex justify-end">
      <button type="submit" class="bg-primary rounded-lg px-10 py-2.5 font-bold text-white">Add to List</button>
    </div>
  </div>
</form>

<div
  *ngIf="temporaryStockList().length > 0"
  class="mt-8 overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
  <table class="w-full text-left text-[13px]">
    <thead class="bg-gray-50 font-bold text-gray-700">
      <tr>
        <th class="px-6 py-4">Product</th>
        <th class="px-6 py-4">Batch</th>
        <th class="px-6 py-4">Qty</th>
        <th class="px-6 py-4">Price</th>
        <th class="px-6 py-4 text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of temporaryStockList()" class="border-t border-gray-100">
        <td class="px-6 py-4">{{ item.productTitle }}</td>
        <td class="px-6 py-4">{{ item.batchNumber }}</td>
        <td class="px-6 py-4">{{ item.quantity }}</td>
        <td class="px-6 py-4">{{ item.peoplePrice }} EGP</td>
        <td class="px-6 py-4 text-center">
          <button (click)="removeItem(item.id!)" class="text-red-500 hover:underline">Remove</button>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="flex justify-center bg-gray-50 p-6">
    <button (click)="submitAll()" class="rounded-lg bg-green-600 px-20 py-3 font-bold text-white shadow-md">
      Submit All ({{ temporaryStockList().length }})
    </button>
  </div>
</div>
